export function confColor(confidence: number | undefined | null): string {
  if (confidence === 0)
    return "bg-no-confidence-bg border-no-confidence-border ";
  if (confidence === 1)
    return "bg-high-confidence-bg border-high-confidence-border ";
  return "";
}
